import React from 'react';
import { useIntl } from 'react-intl';
import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FeatureBoxProps } from './props';

const FeatureBoxComponent: React.FC<FeatureBoxProps> = ({ feature }) => {
  const intl = useIntl();
  return (
    <Col xs={12} md={4}>
      <div className="feature-box sml-box-shadow px-3 py-4 bg-white rounded-3 h-100 my-3 d-flex">
        <div className="d-flex align-items-center justify-content-center px-3 text-secondary">
          <FontAwesomeIcon icon={feature.icon} className="me-3" size="2x" />
        </div>
        <div className="d-flex flex-column justify-content-center">
          <h5>{intl.formatMessage(feature.title)}</h5>
          {feature.description && <span className="font-weight-light">{intl.formatMessage(feature.description)}</span>}
        </div>
      </div>
    </Col>
  );
};

export const FeatureBox = React.memo(FeatureBoxComponent);
